import { Component, OnInit, RendererFactory2, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  Router,
  ActivatedRouteSnapshot,
  NavigationEnd,
  NavigationStart,
  ActivatedRoute,
} from '@angular/router';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { filter, map } from 'rxjs';
import { AccountService } from 'src/app/core/auth/account.service';
import { AuthServerProvider } from 'src/app/core/auth/auth-jwt.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false
})
export class MainComponent implements OnInit {
  private renderer: Renderer2;

  showNavbar = false;
  companyInfo = environment.companyInfo;
  tenantField = environment.tenantField;

  constructor(
    private accountService: AccountService,
    private titleService: Title,
    private router: Router,
    private authService: AuthServerProvider,
    rootRenderer: RendererFactory2,
    private localStorageService: LocalStorageService,
    private sessionStorageService: SessionStorageService,
    private activatedRoute: ActivatedRoute
  ) {
    this.renderer = rootRenderer.createRenderer(
      document.querySelector('html'),
      null
    );
    this.router.events.subscribe((event) => {});
  }

  ngOnInit(): void {
    // try to log in automatically
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        map(() => {
          let r = this.activatedRoute;
          while (r.firstChild) r = r.firstChild;
          return r.snapshot.data;
        })
      )
      .subscribe((data) => {
        const token =
          this.localStorageService.retrieve('authenticationToken') ??
          this.sessionStorageService.retrieve('authenticationToken');

        this.showNavbar = !!token && !data['hideNavbar'];
      });

    // also evaluate once on initial load
    const data = this.activatedRoute.firstChild?.snapshot.data ?? {};
    console.log('data', data);
    const token =
      this.localStorageService.retrieve('authenticationToken') ??
      this.sessionStorageService.retrieve('authenticationToken');
    console.log('token', token);
    this.showNavbar = !!token && !data['hideNavbar'];
  }

  private getPageTitle(routeSnapshot: ActivatedRouteSnapshot): string {
    const title: string = routeSnapshot.data['pageTitle'] ?? '';
    if (routeSnapshot.firstChild) {
      return this.getPageTitle(routeSnapshot.firstChild) || title;
    }
    return title;
  }

  private updateTitle(): void {
    let pageTitle = this.getPageTitle(this.router.routerState.snapshot.root);
    if (!pageTitle) {
      pageTitle = 'global.title';
    }
  }
}
